export default {
  root: {
    "&.Mui-focused": {
      outline: "#DFDFDF solid 3px"
    }
  }
};
